<template>
  <div>
    <div
      v-show="Loginloaded"
      id="divLoading"
      style="
        margin: 0px;
        padding: 0px;
        position: fixed;
        right: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 90001;
        opacity: 1;
        transform: scale(2);
      "
    >
      <!-- <p style="position: fixed; top: 45%; left: 45%;"> -->
      <div class="loader">
        <!-- <div class="item-c item-1"></div>
<div class="item-c item-2"></div>
<div class="item-c item-3"></div>
<div class="item-c item-4"></div>-->
        <svg
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 33 33;270 33 33"
              begin="0s"
              dur="1.4s"
              fill="freeze"
              repeatCount="indefinite"
            />
            <circle
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
              stroke-dasharray="187"
              stroke-dashoffset="610"
            >
              <animate
                attributeName="stroke"
                values="#4285F4;#DE3E35;#F7C223;#1B9A59;#4285F4"
                begin="0s"
                dur="5.6s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0 33 33;135 33 33;450 33 33"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                values="187;46.75;187"
                begin="0s"
                dur="1.4s"
                fill="freeze"
                repeatCount="indefinite"
              />
            </circle>
          </g></svg
        ><span style="font-size: 10px">Loading...</span>
      </div>
      <!-- </p> -->
    </div>
    <!-- Othe msg  Modal -->
    <div id="Othermsg-modal" class="modal fade all-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body p-0">
            <button
              type="button"
              style="margin-top: -10"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.03"
                height="18.031"
                viewBox="0 0 18.03 18.031"
              >
                <path
                  id="close.svg"
                  fill="#242432"
                  d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                  transform="translate(-1412 -516)"
                />
              </svg>
            </button>
            <div id="dvOtherMsg" class="classOtheMsg">
              {{ $t("login.defaulterrormsg") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Othe msg  Modal Ends-->
  </div>
</template>

<script>
import axios from "axios";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";
import firebase from "firebase";
import "firebase/auth";
import router from "../router";
import store from "../store";
import analytics from "@/components/Analytics";
import APIs from "@/components/APIInit";
import eventsubscribe from "@/components/EventSubscribe";

const landingURLOptions = {
  "/lobby": "Lobby",
  "/sessions": "Session",
  "/livestage": "LiveStage",
  "/stageview": "StageView",
  "/attendee": "AttendeeList",
  "/exhibitorshall": "ExhibitorsHall",
  "/mymeetings": "MyMeetings",
  "/myprofile": "MyProfile",
};

var self;
export default {
  data: () => ({
    clientId: "",
    result: "",
    client: "",
    EmailURL: "",
    DynamicColor: "",
    arrEvents: [],
    hostExistcnt: 0,
    Loginloaded: true,
    pageBg: null,
    brandlogo: null,
    microsoftlogin: false,
    googlelogin: false,
    linkedinlogin: false,
    AllowRegister: false,
    bodyTextColor: "#fff",
    loginButtonFillColor: "#f00",
    loginButtonTextColor: "#fff",
    EnableEmailOnlyLogin: false,
  }),

  methods: {
    checkLogin() {
      debugger;
      let customer_guid = this.$route.params.customer_guid;
      let cid = this.$route.params.cid;
      let eid = this.$route.params.eid;
      var apiurl = APIs.JoinApi;
      if (cid == "") {
        apiurl = apiurl + "?extregid=" + customer_guid + "";
      } else {
        apiurl = apiurl =
          apiurl +
          "?cid=" +
          cid +
          "&eid=" +
          eid +
          "&extregid=" +
          customer_guid +
          "";
      }

      var config = {
        method: "get",
        url: apiurl,
        headers: {},
      };
      debugger;
      axios(config)
        .then(function (response) {
          //alert(response.msg);
          firebase
            .auth()
            .signInWithCustomToken(response.data.accessToken)
            .then(function () {
              store.commit("setLoginType", "Login");
              self.getEventDetails(response.data);
            })
            .catch(function (error) {
              //    document.getElementById("dvOtherMsg").innerText =
              //   "Authentication issue"
              // $("#Othermsg-modal").modal("show");
              console.log(error);
              router.push("/");
            });
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          alert(JSON.stringify(error.response.data.msg));
          // self.Loginloaded= false;
          // document.getElementById("dvOtherMsg").innerText =
          //     JSON.stringify(error.response.data.msg);
          //   $("#Othermsg-modal").modal("show");
          console.log(JSON.stringify(error.response.data.msg));
          router.push("/");
        });
    },
    getEventDetails(data) {
      var userData = data.data;
      var email = userData.Email;
      var userRoles = userData.UserRoles;
      var isClientAdmin = false;
      var isEventAdmin = false;
      var roles = [];
      if (userRoles != undefined) {
        userRoles.forEach(function (role) {
          if (role.RoleID == 2) {
            isClientAdmin = true;
          } else if (role.RoleID == 3) {
            isEventAdmin = true;
          }
          roles.push(role.RoleID);
        });
      }
      console.log(roles);
      var channelPrefix = "OAUAT";
      this.createLoginCookieForVideo(userData.UserId, channelPrefix);
      store.commit("addUser", {
        id: userData.UserId,
        Email: email,
        name: userData.Name,
        fname: userData.FirstName,
        lname: userData.LastName,
        profilepic: userData.ProfilePictureURL,
        company: userData.Company,
        title: userData.Designation,
        phone: userData.Phone,
        roles: roles,
      });

      //self.addAnalytics("Login");
      debugger;
      var result = data.userEvents.result;
      var events = [];
      var i;
      var j;
      for (i = 0; i < result.length; ++i) {
        for (j = 0; j < result[i].events.length; j++) {
          if (!isClientAdmin && !isEventAdmin) {
            if (result[i].events[j].IsPublished == true) {
              events.push(result[i].events[j]);
              store.commit("setMappedEvent", result[i].events[j]);
            }
          } else {
            events.push(result[i].events[j]);
            store.commit("setMappedEvent", result[i].events[j]);
          }
        }
      }

      console.log(events);
      store.commit("addEventCount", events.length);

      if (events.length == 0) {
        document.getElementById("dvOtherMsg").innerText = self.$t(
          "login.eventnotpublished"
        );
        $("#Othermsg-modal").modal("show");
        $("#btnLogin").val(self.$t("login.title"));
      } else if (events.length > 1) {
        $("#btnLogin").prop("disabled", true);
        $("#btnLogin").val(self.$t("login.pleasewait"));
        router.push({ name: "EventList" });
      } else {
        $("#btnLogin").prop("disabled", true);
        self.goToEvent(events);
      }
    },

    goToEvent: async function (eventDoc) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      var eventData = eventDoc[0];
      this.$store.state.locale =
        eventData.DefaultLanguage === undefined
          ? "English"
          : eventData.DefaultLanguage;
      //store.commit("addEventID", eventData.id);
      store.commit("addEventID", eventData.EventId);
      store.commit("addEventCollection", eventData.EventCollectionName);
      store.commit("addEventName", eventData.EventFullName);
      store.commit("addEventSdate", eventData.EventStartDate);
      store.commit("addEventEdate", eventData.EventEndDate);
      store.commit("addZone", eventData.TimeZone);
      let clientName = this.$store.state.client[0].name;
      store.commit("addClientID", {
        id: eventData.ClientId,
        name: clientName,
      });

      /*++++++++ Font style EventCustomCSS.json JSON ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
      var brandingData;
      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName +
            "/Branding/CustomStyle/EventCustomCSS.json"
        );
        if (brandingData.data.customClientFont != undefined) {
          store.commit("AddEventFont", {
            FontPath: brandingData.data.customClientFont.FontPath,
            FontFamily: brandingData.data.customClientFont.FontFamily,
          });
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }
      await db
        .collection(eventData.EventCollectionName)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("Email", "==", email)
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var AttendeeID = doc.data().AttendeeId;
            store.commit("addAttendeeID", AttendeeID);
          });
        })
        .catch((error) => {
          console.log(error);
        });

      try {
        brandingData = await self.getBrandingJSONDetails(
          eventData.EventCollectionName + "/Branding/Branding.json"
        );
        if (brandingData.data != undefined) {
          this.item = brandingData.data;

          var bannerDymension = "2048x88";
          var EventBgDymension = "2732x2048";
          var logoDymension = "960x192";

          store.commit("addEventBranding", {
            eventBGImage: brandingData.data.eventBGImage[EventBgDymension], //data.LoginAssets.bg2732x2048,
            eventLogo: brandingData.data.eventLogo[logoDymension],
            topBar: brandingData.data.headerColorsHexCode["topBar"],
            headerBar: brandingData.data.headerColorsHexCode["headerBar"],
            fontBar: brandingData.data.headerColorsHexCode["fontBar"],
            sideNavigationAndIconColor:
              brandingData.data.headerColorsHexCode[
                "sideNavigationAndIconColor"
              ],
            banner: brandingData.data.banner[bannerDymension],
            mobileBanner: self.getCDNUrl(brandingData.data.banner["750x103"]),
            shareBanner: self.getCDNUrl(
              brandingData.data.banner["1200x628"]
                ? brandingData.data.banner["1200x628"]
                : ""
            ),
            themeName: brandingData.data["appColorHexCodeType"],
          });
          $("#btnLoadMenu").click();

          let landingURL = "Lobby";
          if (
            eventData.DefaultLandingURL &&
            landingURLOptions[eventData.DefaultLandingURL] &&
            landingURLOptions[eventData.DefaultLandingURL] != ""
          ) {
            landingURL = landingURLOptions[eventData.DefaultLandingURL];
          }

          if (landingURL === "ExhibitorsHall") {
            this.onExpoSelection();
            store.commit("setAdvExpo", true);
          }
          analytics.AddUserLogin(
            eventData.EventCollectionName,
            eventData.EventFullName,
            location.pathname,
            "click",
            "action",
            obj.loginType,
            obj.user[0].id,
            obj.user[0].fname.trim() + " " + obj.user[0].lname.trim(),
            obj.user[0].Email,
            obj.ClientIP
          );
          router.push({
            name: landingURL,
            params: {
              sid: eventDoc.id,
              eCol: eventData.EventCollectionName,
              ename: eventData.EventFullName,
              estartdt: eventData.EventStartDate,
              eenddt: eventData.EventEndDate,
              tzone: eventData.TimeZone,
            },
          });
        }
      } catch (e) {
        console.log("Error in Branding Json Fetch--", e);
      }
    },

    AddAnalitics: function (btnName, action) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined) {
        var eventName;
        if (obj.eventname !== undefined) {
          eventName = obj.eventname;
        } else {
          eventName = "";
        }
        var actionType = "";
        var actionLabel = "";
        if (action !== "scroll") {
          actionType = btnName.target.tagName.toLowerCase();
          if (btnName.target.getAttribute("data-tag") !== undefined) {
            if (btnName.target.getAttribute("data-tag") === null) {
              return false;
            }
            actionLabel = btnName.target.getAttribute("data-tag");

            if (actionLabel !== "") {
              this.event_collectionName = obj.eventcollectionname;
              analytics.AddUserAction(
                this.event_collectionName,
                eventName,
                location.pathname,
                action,
                actionType,
                actionLabel,
                obj.user[0].id,
                obj.user[0].fname + " " + obj.user[0].lname,
                obj.user[0].Email
              );
            }
          }
        } else {
          this.event_collectionName = obj.eventcollectionname;
          analytics.AddUserAction(
            this.event_collectionName,
            eventName,
            location.pathname,
            action,
            actionType,
            actionLabel,
            obj.user[0].id,
            obj.user[0].fname + " " + obj.user[0].lname,
            obj.user[0].Email
          );
        }
      }
    },

    getAttendeeID: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var email = obj.user[0].Email;
      //var EventID = obj.eventid;

      db.collection(obj.eventcollectionname)
        .doc("AttendeeList")
        .collection("Attendees")
        .where("Email", "==", email)
        //.where("MappedEvents", "array-contains", EventID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //
            var data = doc.data();
            var AttendeeID = data.AttendeeId;
            store.commit("addAttendeeID", AttendeeID);
          });
        })
        .catch((error) => {
          //alert(error);
          console.log(error);
        });
    },

    getMeetingSettings: function () {
      debugger;
      const obj = JSON.parse(window.localStorage["my-app"]);
      let headers = {
        Authorization: "Bearer " + self.getSessionToken(),
        "content-type": "application/json",
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },
      };
      axios
        .post(APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          debugger;
          console.log(response);
          var res = response.data;
          var MObj = new Object();
          MObj.Slot = res.data.Slots;
          MObj.StartDate = res.data.StartDate;
          MObj.EndDate = res.data.EndDate;
          MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
          MObj.AvailabilityToTime = res.data.AvailabilityToTime;
          MObj.ButtonLabel = res.data.ButtonLabel;
          MObj.Duration = res.data.Duration;
          if (res.data.ByTimezone !== undefined) {
            MObj.ByTimezone = res.data.ByTimezone;
          } else {
            MObj.ByTimezone = false;
          }
          if (res.data.Items && res.data.Items.length > 0) {
            MObj.Items = res.data.Items;
          }

          store.commit("addMeetingSettings", MObj);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAdvExpoStatus: function () {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection(obj.eventcollectionname)
        .doc("Settings")
        .collection("Exhibitor")
        .get()
        .then((querySnapshot) => {
          this.SubscribeForWebPush(); //kk
          querySnapshot.forEach((doc) => {
            if (doc.data().EnableEnhancedExpoMode === true) {
              store.commit("setAdvExpo", true);
            } else {
              store.commit("setAdvExpo", false);
            }
          });
        })
        .catch((error) => {
          alert(error);
        });
    },
    onExpoSelection() {
      $("#liexhibitor")
        .find("a:first")
        .addClass("router-link-exact-active router-link-active");
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname !== undefined) {
        if (obj.eventcollectionname !== "") {
          db.collection(obj.eventcollectionname)
            .doc("Settings")
            .collection("Exhibitor")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                if (doc.data().EnableEnhancedExpoMode === true) {
                  router.push("/exhibitorshall");
                  store.commit("setAdvExpo", true);
                } else {
                  store.commit("setAdvExpo", false);
                  router.push("/exhibitor");
                }
              });
            })
            .catch((error) => {
              alert(error);
            });
        }
      }
    },

    SubscribeForWebPush() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      eventsubscribe.SubscribeUser(
        obj.eventcollectionname,
        obj.user[0].Email,
        obj.user[0].id,
        obj.ShowNotification
      );
    },

    createLoginCookieForVideo: function (UserID, channelPrefix) {
      var cookieExpDate = new Date();
      var minutes = 1440 * 7; //7 days
      cookieExpDate.setTime(cookieExpDate.getTime() + minutes * 60 * 1000);
      var val = channelPrefix + "_" + UserID.toString();
      document.cookie =
        "vuid=" +
        val +
        "; expires=" +
        cookieExpDate +
        "; path=/;domain=.e2m.live;secure=true";
    },
  },
  mounted: function () {
    self = this;
    $("#topmenu").hide();
    $("#leftmenu").hide();
    self.checkLogin();
  },
};
</script>
